import axios from 'axios';
import sdata from './_/sdata'
import sname from './_/sname'

export default function (context, val) {
    let name = val;
    let setting = context.state[name];
    let data = {
        ScreenName: sname(name),
        ViewType: setting.type,
        ItemsPerPage: setting.col,
        ItemsLegend: [],
        CustomSettings: [
            {
                Name: 'setting',
                Value: JSON.stringify(setting.setting)
            },
            {
                Name: 'height',
                Value: JSON.stringify(setting.height)
            },
            {
                Name: 'heightFixed',
                Value: JSON.stringify(setting.heightFixed)
            },
            {
                Name: 'search',
                Value: JSON.stringify(setting.search)
            },
            {
                Name: 'defaultFilter',
                Value: JSON.stringify(setting.defaultFilter)
            },
            {
                Name: 'filters',
                Value: JSON.stringify(setting.filters)
            },
            {
                Name: 'opened',
                Value: JSON.stringify(setting.opened)
            },
            {
                Name: 'reopenPayToAgreement',
                Value: JSON.stringify(setting.reopenPayToAgreement)
            },

        ],
    };
    setting.columns.forEach(j => {
        setting.data.ItemsLegend.forEach(i => {
            if (i.FieldName !== j.name) return;
            i.IsFixed = j.fixed;
            i.IsVisible = j.visible;
            i.ColumnWidth = j.width;
            i.ColumnIndex = j.index;
            data.ItemsLegend.push(i);
        });
    });
    context.state[name].rebind = false;
    setTimeout(() => {
        context.state[name].rebind = true;
    });
    setting.data = data;
    setting.visible = false;
    axios({
        method: 'post',
        url: '/tourclient/legend/updateLegend',
        data: 'request=' + JSON.stringify(data),
    }).then(r => {
        window.app.$notify({
            title: 'Сохранение',
            message: 'Настройки успешно сохранены',
            type: 'success',
        });
    }).catch(e => {
        context.dispatch('error', e, {root: true});
    });
}